import React, { useState, useEffect } from 'react';
import NonGeneratingUsers from '../components/Auth/NonGeneratingUsers';
import { fetchNonGeneratingUsers } from '../services/reportService';

const NonGeneratingUsersPage: React.FC = () => {
    const [nonGeneratingUsers, setNonGeneratingUsers] = useState<any[]>([]);
    const [nonGeneratingLoading, setNonGeneratingLoading] = useState<boolean>(false)
    const [headerDates, setHeaderDates] = useState<string[] | undefined>(undefined);
    
    useEffect(() => {
        setNonGeneratingLoading(true);
        const fetchNonGeneratingUserReport = async () => {
          await fetchNonGeneratingUsers()
            .then((res) => {
              const raw = (res && res.data) ? res.data : [];
              const mapped = raw.map((u: any) => {
                const daysObj = u.energy_last_three_days || {};
                const sortedDates = Object.keys(daysObj).sort();
                const daysArr = sortedDates.map((k) => daysObj[k]);
                return {
                  consumer_name: u.consumer_name,
                  provider_name: u.provider_name,
                  capacity: u.capacity,
                  energy: daysArr[daysArr.length - 1] ?? 0,
                  energy_last_three_days: daysArr,
                };
              });
              setNonGeneratingUsers(mapped);
              if (raw && raw.length > 0) {
                const firstDaysObj = raw[0].energy_last_three_days || {};
                const firstSortedDates = Object.keys(firstDaysObj).sort();
                setHeaderDates(firstSortedDates.slice(-3));
              }
            })
            .catch((err) => console.error('Error fetching non-generating users:', err))
            .finally(() => setNonGeneratingLoading(false));
        };
    
        fetchNonGeneratingUserReport();
      }, []);
    return (
        <div>
             <NonGeneratingUsers
                  users={nonGeneratingUsers}
                  loading={nonGeneratingLoading}
                  headerDates={headerDates}
                />
        </div>
    );
};

export default NonGeneratingUsersPage;